import { Badge } from '@/components/ui/badge'
import { Text } from '@/components/ui/text'
import { AppTooltip } from '@components/AppTooltip'
import dayjs from 'dayjs'
import { Bookmark, Star } from 'lucide-solid'
import { type Component, Show } from 'solid-js'
import { Flex } from 'styled-system/jsx'
import { promptTooltipClass } from '../promptTooltipClass'
import type { EnrichedSetup } from './state'
import { MessageCount } from './Card/MessageCount'

interface SocialBadgesProps {
  setup?: EnrichedSetup
  gap?: string
}

// The prototype's social(c) row — chat / PHQ / community score / New — shared
// between the card and list (rail) layouts so both match exactly.
export const SocialBadges: Component<SocialBadgesProps> = (props) => {
  const isNew = () => dayjs(props.setup?.created_at).isAfter(dayjs().subtract(3, 'day'))

  return (
    <Flex
      gap={props.gap || '1.5'}
      alignItems="center"
      flexShrink={0}
    >
      <MessageCount channelId={props.setup?.channel_id} />
      <Show when={props.setup?.commander_score}>
        <AppTooltip
          delay={900}
          content='Potential High Quality Score'
          contentClass={promptTooltipClass}
        >
          <Badge
            variant="outline"
            justifyContent="center"
            h='25px'
            px='9px'
            borderRadius='8px'
            gap='5px'
          >
            <Bookmark
              size={12}
              fill='var(--colors-editorial-accent-deep)'
              stroke='var(--colors-editorial-accent-deep)'
            />
            <Text
              fontSize='11px'
              fontWeight='600'
              color='editorialAccentDeep'
            >
              PHQ {props.setup?.commander_score}
            </Text>
          </Badge>
        </AppTooltip>
      </Show>
      <Show when={props.setup?.community_score}>
        <AppTooltip
          delay={900}
          content='Community Score'
          contentClass={promptTooltipClass}
        >
          <Badge
            variant="outline"
            justifyContent="center"
            h='25px'
            px='9px'
            borderRadius='8px'
            gap='5px'
          >
            <Star
              size={12}
              fill='var(--colors-editorial-star)'
              stroke='var(--colors-editorial-star)'
            />
            <Text
              fontSize='11px'
              fontWeight='600'
              color='editorialInk'
            >
              {props.setup?.community_score}
            </Text>
          </Badge>
        </AppTooltip>
      </Show>
      <Show when={isNew()}>
        <AppTooltip
          delay={900}
          content='Newly Posted Setup'
          contentClass={promptTooltipClass}
        >
          <Badge
            justifyContent="center"
            w='48px'
            h='25px'
            borderRadius='8px'
            fontSize='10.5px'
            fontWeight='700'
            bg='editorialAccent'
            color='editorialBadgeFg'
          >
            <span style={{ 'letter-spacing': '.04em', 'margin-right': '-.04em' }}>NEW</span>
          </Badge>
        </AppTooltip>
      </Show>
    </Flex>
  )
}
